export const Logo = ({ size = "md", className = "" }) => {
  const main = {
    sm: "text-2xl",
    md: "text-4xl md:text-5xl",
    lg: "text-6xl md:text-7xl lg:text-8xl",
  }[size];

  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="lamaison-logo">
      <span className={`font-serif font-medium text-gold ${main} leading-none`}>
        La Maison
      </span>
      <span className="flex items-center gap-3 mt-2">
        <span className="logo-line" />
        <span className="font-sans tracking-luxury text-gold text-[0.65rem] md:text-xs uppercase">
          by FP
        </span>
        <span className="logo-line" />
      </span>
    </div>
  );
};
